import * as THREE from "three/webgpu";
import {OrbitControls} from "three/addons/controls/OrbitControls.js";
import Experience from "./Experience.js";

export default class Camera {
    constructor() {
        this.experience = new Experience();
        this.sizes = this.experience.sizes;
        this.scene = this.experience.scene;
        this.canvas = this.experience.canvas;
        
        // 1. Track the cursor position
        this.cursor = { x: 0, y: 0 };
        window.addEventListener('mousemove', (event) => {
            // Normalize cursor coordinates from -0.5 to 0.5
            this.cursor.x = (event.clientX / this.sizes.width) - 0.5;
            this.cursor.y = (event.clientY / this.sizes.height) - 0.5;
        });
        
        this.setInstance();
        this.setOrbitControls();
    }
    
    setInstance() {
        // 2. Wrap the camera in a group
        this.instanceGroup = new THREE.Group();
        this.scene.add(this.instanceGroup);

        this.instance = new THREE.PerspectiveCamera(
            60,
            this.sizes.width / this.sizes.height,
            0.1,
            100
        );
        
        this.instance.position.set(0, 4, -8);
        this.instanceGroup.add(this.instance); // Add camera to group, not scene
    }

    setOrbitControls() {
        this.controls = new OrbitControls(this.instance, this.canvas);
        this.controls.enableDamping = true;
        
        // 3. Disable all manual clicking/dragging/zooming
        this.controls.enableRotate = false;
        this.controls.enableZoom = false;
        this.controls.enablePan = false;
    }
    
    resize() {
        this.instance.aspect = this.sizes.width / this.sizes.height;
        this.instance.updateProjectionMatrix();
    }
    
    update() {
        this.controls.update();

        // 4. Smoothly sway the wrapper group based on cursor
        // We only apply this after the intro animation finishes (controls enabled)
        if (this.controls.enabled) {
            // Tweak the 0.5 multipliers to make the sway wider or narrower
            const parallaxX = this.cursor.x * 0.6; 
            const parallaxY = -this.cursor.y * 0.6;

            // Tweak 0.05 for faster/slower smoothness
            this.instanceGroup.position.x += (parallaxX - this.instanceGroup.position.x) * 0.05;
            this.instanceGroup.position.y += (parallaxY - this.instanceGroup.position.y) * 0.05;
        }
    }
}